import React, { createContext, useContext, useState } from "react";

const FormContext = createContext();

export function FormProvider({ children }) {
	const [formData, setFormData] = useState({
		user_team_number: 0,
		username: "",
		user_id: 0,
		event: "",
		match_number: 0,
		robot_number: 0,
		auto_actions: [],
		teleop_level4: 0,
		teleop_level3: 0,
		teleop_level2: 0,
		teleop_level1: 0,
		teleop_net_scored: 0,
		teleop_net_missed: 0,
		teleop_processor_scored: 0,
		teleop_missed_coral: 0,
		endgame_type: "no_attempt",
		robot_speed: 3,
		robot_agility: 3,
		robot_defense: 0,
		robot_climbing_speed: 0,
		robot_dislodge_algae: 0,
		robot_algae_controlled: 0,
		robot_coral_can_handle: 0,
		robot_travel_under_barge: 0,
		errors_mistakes_lost_comms: 0,
		errors_mistakes_stuck_piece: 0,
		errors_mistakes_extra_piece: 0,
		errors_official_yellow_card: 0,
		errors_official_red_card: 0,
		robot_tippy: 0,
		robot_tipped: 0,
		robot_damaged: 0,
		errors_gameplay_battlebot: 0,
		errors_official_foul: 0,
		errors_gameplay_nuisance: 0,
		errors_gameplay_touched_cage: 0,
		errors_gameplay_knocked_cage: 0,
		notes: "",
		year: 2025,
		starting_location: -1,
	});

	const updateFormData = (newData) => {
		setFormData((prev) => ({ ...prev, ...newData }));
	};

	return <FormContext.Provider value={{ formData, updateFormData }}>{children}</FormContext.Provider>;
}

export function useFormData() {
	const context = useContext(FormContext);
	if (!context) {
		throw new Error("useFormData must be used within a FormProvider");
	}
	return context;
}
